"use client";

import { useScrollDepthEvent } from "@/app/hooks/useScrollDepthEvent";
import type { DiscoveryEventKey } from "@/app/actions/trackDiscoveryEventUtils";

/**
 * Declarative wrapper around `useScrollDepthEvent` for rendering from a
 * server component, mirroring `MixpanelTrackEvent`'s "fire on mount" pattern.
 */
export function ScrollDepthTracker(t0) {
  const {
    event,
    properties
  } = t0;
  useScrollDepthEvent(event, properties);
  return null;
}